import {
  Dialog,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  ListSubheader,
  Typography,
} from "@mui/material";
import { isEmpty } from "lodash-es";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import type { CaseBase } from "src/types";
import { parseServerError } from "src/utils/string.utils";

export interface Props {
  open: boolean;
  case: CaseBase;
  onClose: (event: MouseEvent) => void;
}

export function CaseErrorsDialog(props: Props) {
  const { onClose, open } = props;
  const { creationErrors, runErrors, copyErrors } = props.case;
  const { t } = useTranslation();

  function handleClose(event: MouseEvent) {
    onClose(event);
  }

  return (
    <StyledDialog onClose={handleClose} open={open}>
      {!isEmpty(creationErrors) && (
        <>
          <DialogTitle className="title">
            <Typography variant="h2">{t("label.creationErrors")}</Typography>
          </DialogTitle>

          <DialogContent>
            <List>
              {creationErrors.map((errorItem, i) => (
                <ListItem key={[errorItem.key, i].join()} divider={i + 1 < creationErrors.length} disableGutters>
                  <ListItemText primary={parseServerError(errorItem)} />
                </ListItem>
              ))}
            </List>
          </DialogContent>
        </>
      )}

      {!isEmpty(runErrors) && (
        <>
          <DialogTitle className="title">
            <Typography variant="h2"> {t("label.scenarioErrors")}</Typography>
          </DialogTitle>
          <DialogContent>
            {runErrors.map((runErrorItem, i) => (
              <List key={[runErrorItem.scenarioId, i].join()}>
                <ListSubheader disableGutters className="scenario-title">
                  <span>{t("label.scenario")}:</span> {runErrorItem.scenarioName}
                </ListSubheader>
                {runErrorItem.errors.map((errorItem, j) => (
                  <ListItem
                    key={[errorItem.key, i, j].join()}
                    disableGutters
                    divider={i + 1 < runErrorItem.errors.length}
                  >
                    <ListItemText key={errorItem.key} primary={parseServerError(errorItem)} />
                  </ListItem>
                ))}
              </List>
            ))}
          </DialogContent>
        </>
      )}
      {!isEmpty(copyErrors) && (
        <>
          <DialogTitle className="title">
            <Typography variant="h2">{t("label.copyErrors")}</Typography>
          </DialogTitle>
          <DialogContent>
            <List>
              {copyErrors.map((errorItem, i) => (
                <ListItem key={[errorItem.key, i].join()} divider={i + 1 < copyErrors.length} disableGutters>
                  <ListItemText primary={parseServerError(errorItem)} />
                </ListItem>
              ))}
            </List>
          </DialogContent>
        </>
      )}
    </StyledDialog>
  );
}

const StyledDialog = styled(Dialog)`
  .MuiDialogContent-root,
  .MuiList-root {
    padding-top: 0;
  }

  .title {
    padding-bottom: 0;
    .MuiTypography-root {
      color: ${({ theme }) => theme.palette.error.main};
    }
  }
  .scenario-title {
    span {
      text-transform: italic;
      font-style: italic;
    }
    padding-bottom: 0;
    height: 30px;
  }
`;
